import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useGetUserProfile } from '../../network/queries/Profile';

export const UsersList = ({ users, stores, roles }) => {
    const { t } = useTranslation();

    const { data = {} } = useGetUserProfile();
    const currentUser = data.data || {};

    return (
        <table className="min-w-full border-b border-gray-100 mt-5">
            <thead>
                <tr>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Name')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Email')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Stores')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Role')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider"></th>
                </tr>
            </thead>
            <tbody className="bg-white">
                {users.map((user) => {
                    const storeName = stores.find((store) => store.value === user.restaurant_id)?.label || '';
                    const roleName = roles.find((role) => role.value === user.role_id)?.label || '';

                    return (
                        <tr key={user.id} className="odd:bg-gray-50">
                            <td className="px-6 p-5 whitespace-nowrap">
                                <div className="flex items-center">
                                    {currentUser.id !== user.id ? (
                                        <Link to={`/chain/users/${user.id}/edit`} className="text-indigo-600 hover:text-indigo-900">
                                            {user.name}
                                        </Link>
                                    ) : (
                                        <span>{user.name}</span>
                                    )}
                                </div>
                            </td>
                            <td className="px-6 py-2 whitespace-nowrap">
                                <div className="flex items-center">
                                    <div className="text-sm flex flex-col gap-1">
                                        <div>{user.email}</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm">{storeName || 'All (Admin Defualt)'}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm capitalize">{roleName}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm">
                                    {currentUser.id !== user.id ? (
                                        <Link to={`/chain/users/${user.id}/edit`} className="text-indigo-600 hover:text-indigo-900">
                                            {t('Edit')}
                                        </Link>
                                    ) : null}
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
